/* lua.js generated code 0.3.1 */
require("clover/data/ItemDataManager")
require("clover/logic/userLevel/UserLevel")
PrepropRecordManager = xClass("PrepropRecordManager")
//挑战多少次最高关卡切没通关出现道具使用提示
let challengeLimit = 2
let _instance = null
PrepropRecordManager.getInstance = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    if (!_instance) {
        _instance = PrepropRecordManager.new()
    }
    return _instance
}
PrepropRecordManager.prototype.ctor = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    self.topLevelChallengeTimes = 0
    self.topLevelUsePrepropNum = 0
    self.topLevelId = 0
    self.levelChallengeTimes = table()
    self.addEventListeners()
    self.readPrepropRecord()
}
PrepropRecordManager.prototype.readPrepropRecord = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    let data = Localhost.getInstance().getPrepropUseRecord() || table()
    self.topLevelId = tonumber(data.topLevelId || 0)
    self.topLevelUsePrepropNum = tonumber(data.topLevelUsePrepropNum || 0)
    self.topLevelChallengeTimes = tonumber(data.topLevelChallengeTimes || 0)
    let $st6 = data.levelChallengeTimes || table()
    for (let k = 1, v = $st6[1]; v; k++, v = $st6[k]) {
        self.levelChallengeTimes[tonumber(v.levelId || 0)] = tonumber(v.times || 0)
    }
}
PrepropRecordManager.prototype.savePrepropRecord = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    let data = table()
    data.topLevelId = self.topLevelId
    data.topLevelUsePrepropNum = self.topLevelUsePrepropNum
    data.topLevelChallengeTimes = self.topLevelChallengeTimes
    data.levelChallengeTimes = table()
    let $st10 = self.levelChallengeTimes
    for (let k in $st10) {
        let v = $st10[k]
        if ($null(v)) continue
        table.insert(data.levelChallengeTimes, table([1, "levelId", k], [1, "times", v]))
    }
    Localhost.getInstance().setPrepropUseRecord(data)
}
PrepropRecordManager.prototype.addEventListeners = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    UserLevel.getInstance().on(UserLevelEvent.StartLevel, function (event) {
        let levelId = event.levelId
        let topLevelId = UserManager.getInstance().getUserRef().getTopLevelId()
        if (self.topLevelId !== topLevelId) {
            self.topLevelId = topLevelId
            self.topLevelUsePrepropNum = 0
            self.topLevelChallengeTimes = 0
        }
        let star = UserScore.getInstance().getScore(levelId).star
        if (levelId === topLevelId && star === 0) {
            let itemList = event.itemList
            if (Math.mod(self.topLevelChallengeTimes, challengeLimit) === 0) {
                self.topLevelUsePrepropNum = 0
            }
            self.topLevelChallengeTimes = self.topLevelChallengeTimes + 1
            self.topLevelUsePrepropNum = self.topLevelUsePrepropNum + $len(itemList)
        } else {
            let digest = LevelConfigManager.getInstance().getLevelDigest(levelId)
            let starMax = $len((digest && digest.scoreTargets || table()))
            if (starMax > 0) {
                if (star < starMax) {
                    if (!self.levelChallengeTimes[levelId]) {
                        self.levelChallengeTimes[levelId] = 0
                    }
                    self.levelChallengeTimes[levelId] = self.levelChallengeTimes[levelId] + 1
                } else {
                    self.levelChallengeTimes[levelId] = null
                }
            }
        }
        self.savePrepropRecord()
    })
}
let SUPERBIRD_CHECKPOINT = table(
    3,
    6,
    9
)
PrepropRecordManager.prototype.checkSuperBird = function (levelId) {
    let self = this
    if (!self.levelChallengeTimes[levelId]) {
        return 0
    }
    let checkPoint = false
    for (let _ = 1, v = SUPERBIRD_CHECKPOINT[1]; v; _++, v = SUPERBIRD_CHECKPOINT[_]) {
        if (self.levelChallengeTimes[levelId] === v) {
            checkPoint = true
        }
    }
    if (checkPoint) {
        let superBirdId = GamePropIds.kSuperBird_b
        let superBirdNum = UserProp.getInstance().getPropNumber(superBirdId)[0]
        if (superBirdNum > 0) {
            return superBirdId
        } else if (UserCash.getInstance().getCash() >= 69) {
            return superBirdId
        } else {
            return 0
        }
    } else {
        return 0
    }
}
PrepropRecordManager.prototype.checkRecommend = function (levelId) {
    let self = this
    let topLevelId = UserManager.getInstance().getUserRef().getTopLevelId()
    //  如果关前道具的解锁等级改了，这里也要改
    if (topLevelId < 21) {
        return 0
    }
    let gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
    let gamePropMeta = MetaManager.getGameModePropByModeId(gameMode)
    if(gamePropMeta == null) {
        return 0
    }
    var availableItem = table()
    let $st31 = gamePropMeta.initProps_item || table()
    //  主线关卡，启用新的关前道具逻辑
    for (let i = 1, v = $st31[1]; v; i++, v = $st31[i]) {
        let itemData = ItemDataManager.getItemDataById(v[0])
        let goodsId = UserDealData.getGoodsIdForProp(itemData.propId)
        //let discountGoodsId = UserDealData.getDiscountGoodsIdIfAvaliable(goodsId, 1)
        let goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
        //let discountGoodsMeta = MetaManager.getInstance().getGoodsMeta(discountGoodsId)
        if (goodsMeta.level <= topLevelId) {
            table.insert(availableItem, itemData.propId)
        }
    }
    let star = UserScore.getInstance().getScore(topLevelId).star
    //  检查开场是否需要补道具
    if (levelId === topLevelId && star === 0) {
        if (self.topLevelId === topLevelId) {
            let isCheckPoint = (Math.mod(self.topLevelChallengeTimes, challengeLimit) === 0)
            if (!isCheckPoint || self.topLevelUsePrepropNum >= 3) {
                return 0
            }
            var coin = UserCoin.getInstance().getCoin()
            var cash = UserCash.getInstance().getCash()

            let gamePropMeta = MetaManager.getGameModePropByModeId(gameMode)
            let initProps_item = gamePropMeta.initProps_item || table()
            let itemList = table()
            for (let i = 1, v = initProps_item[1]; v; i++, v = initProps_item[i]) {
                var itemData = ItemDataManager.getItemDataById(v[0])

                /**
                 * 当前是否可以购买指定Item物品
                 * @param {*} itemData 
                 * @param {*} coin 
                 * @param {*} cash 
                 */
                function canBuy(itemData, coin, cash) {
                    if (itemData.payType === ItemDataManager.PayTypeEnum.Coin) {
                        if (coin >= itemData.price) {
                            return true
                        } else {
                            return false
                        }
                    } else if (itemData.payType === ItemDataManager.PayTypeEnum.Cash) {
                        if (cash >= itemData.price) {
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                }

                if (!table.indexOf(itemList, itemData.propId) && canBuy(itemData, coin, cash) && UserProp.getInstance().getPropNumber(itemData.propId)[0] === 0 && table.indexOf(availableItem, itemData.propId) && (itemData.propId != GamePropIds.kSuperBird_b)) {
                    table.insert(itemList, itemData.propId)
                }
            }

            if ($len(itemList) > 0) {
                let random = math.random($len(itemList))
                return itemList[random]
            } else {
                return 0
            }
        } else {
            return 0
        }
    } else {
        // WARN: maybe multi result
        return self.checkSuperBird(levelId)
    }
}
